export const validateUrl = (value: string) => {
    try {
        const url = new URL(value);
        if (url.protocol === 'http:' || url.protocol === 'https:') {
            let { hostname } = url;
            if (!hostname.endsWith('.')) {
                hostname += '.';
            }
            if (/^(([0-9a-z]|[0-9a-z][-0-9a-z]{0,61}[0-9a-z])\.)+$/i.test(hostname)) {
                return null;
            }
        }
        // eslint-disable-next-line no-empty
    } catch {}
    return 'Enter a valid website URL.';
};

export const validateEmailAddress = (value: string) =>
    !/^\s*[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*\s*$/.test(
        value,
    ) && 'Enter a valid email address.';
